module.exports = __webpack_public_path__ + "static/new-logo-e74709993bd9c0a14736f5b55ad79c25.png";